<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <cr-option />
      </div>
    </div>
</section>
</template>

<script>
import crOption from './Temp/CrOptionTemp.vue'

export default {
  name: 'Tables',
  components: {
    'cr-option': crOption
  },
  methods: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CrMenuOption.vue?d27d2bc0